class DevicesCheck {
  public isIOS() {
    // Exclude Microsoft platforms (e.g., older Windows browsers) to avoid false iOS detection
    // @ts-expect-error MSStream is largely obsolete but some older devices might have it
    const notMicrosoftDevice = !window.MSStream;

    // Check if the user agent matches iOS devices
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && notMicrosoftDevice;
  }

  public isSafari() {
    // Check if the user agent matches Safari browsers
    return (
      /AppleWebKit/.test(navigator.userAgent) &&
      !/Chrome/.test(navigator.userAgent) &&
      !/CriOS/.test(navigator.userAgent) &&
      !/FxiOS/.test(navigator.userAgent)
    );
  }
}

export const devicesCheck = new DevicesCheck();
